import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteGuard } from "@/components/auth/RouteGuard";

export const Route = createFileRoute("/_authenticated/rfqs")({
  component: () => (
    <RouteGuard module="rfqs"><Outlet /></RouteGuard>
  ),
});
